import { Pipe, PipeTransform } from '@angular/core';
import { StatusType } from '../constants/status.type';
import { HearingComment } from '../models/hearing-comment.model';
import { HearingRequestDetailsModel } from '../models/hearing-request-details.model';

@Pipe({
  name: 'hearingComments',
  pure: true,
})
export class HearingCommentsPipe implements PipeTransform {
  constructor() {}

  public StatusType: StatusType;

  transform(value: HearingRequestDetailsModel): HearingComment {
    let hearingComment: HearingComment;
    if (
      value?.hearingStatusCode == StatusType.Rejected ||
      value?.hearingStatusCode == StatusType.AdjournmentRejected
    ) {
      hearingComment = new HearingComment({
        comment: value?.decisionComments,
        commentDate: new Date(),
        commentedBy: 'Coordinator',
      });
    } else if (
      (value?.hearingStatusCode == StatusType.Submitted ||
        value?.hearingStatusCode == StatusType.AdjournmentPending ||
        value?.hearingStatusCode == StatusType.AdjournmentSineDiePending) &&
      value?.isUrgent
    ) {
      hearingComment = new HearingComment({
        comment: value?.urgencyComments,
        commentDate: new Date(),
        commentedBy: value?.requester.name.firstLast,
      });
    } else if (
      (value?.hearingStatusCode == StatusType.Submitted ||
        value?.hearingStatusCode == StatusType.AdjournmentPending ||
        value?.hearingStatusCode == StatusType.AdjournmentSineDiePending) &&
      !value?.isUrgent
    ) {
      hearingComment = new HearingComment({
        comment: value?.comments,
        commentDate: new Date(),
        commentedBy: value?.requester.name.firstLast,
      });
    } else {
      hearingComment = new HearingComment({
        comment: value?.decisionComments,
        commentDate: new Date(),
        commentedBy: 'Coordinator',
      });
    }
    return hearingComment;
  }
}
